/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

// let showToast: (msg: string) => void;

// export const setToastFunction = (fn: (msg: string) => void) => {
//   showToast = fn;
// };

// export const triggerToast = (msg: string, type?: "success" | "error") => {
//   if (showToast) showToast(msg);
// };

let showToast: (msg: string, type?: "success" | "error") => void;

export const setToastFunction = (fn: (msg: string, type?: "success" | "error") => void) => {
  showToast = fn;
};

export const triggerToast = (msg: string, type?: "success" | "error") => {
  if (showToast) showToast(msg, type);
};
